import { PDFViewerAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import { RelatorioPdfAliases as Aliases, FragmentNames } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.RELATORIO_PDF })
export default class PDFViewerController extends BaseController {

  @OnMount(Aliases.PDF_VIEWER)
  onMountPdf(event: MountEvent): void {
    const api = event.target as PDFViewerAPI;
    const { src } = this.context.getBulkData();
    const encode = new Buffer(src as string).toString('base64');
    api.setSrc(Endpoints.GET.REPORT_BY_PATH.replace(':path', encode));
  }
}
